"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOrderModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var useTransactions_1 = require("../../hooks/useTransactions");
var styles_1 = require("../../styles");
var states_1 = require("./states");
var Main_1 = require("./states/Main");
var CreateOrderModal = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, useTransactions_1.useSubmitOrderFlow)(), onSubmit = _c.mutate, swapState = _c.swapState, error = _c.error;
    var content = (0, jsx_runtime_1.jsx)(Main_1.Main, { onSubmit: onSubmit });
    if (swapState === "failed") {
        content = (0, jsx_runtime_1.jsx)(states_1.Failed, { error: error });
    }
    if (swapState === "success") {
        content = (0, jsx_runtime_1.jsx)(states_1.OrderSubmitted, {});
    }
    return (0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: "".concat(className, " twap-create-order-content") }, { children: content }));
};
exports.CreateOrderModal = CreateOrderModal;
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    gap: 0,
});
exports.CreateOrderModal.Main = Main_1.Main;
